import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';
import Echo from 'laravel-echo';
import { environment } from 'src/environments/environment';
import Pusher from 'pusher-js';


declare global {
  interface Window {
    Pusher: typeof Pusher;
  }
}

/**
 * Service for socket
 */
@Injectable({ providedIn: 'root' })
/**
 * Service for socket
 * @class SocketService
 */
export class SocketService {
  /**
   * inject storage service
   * @param {StorageService} storageService
   */
  private storageService = inject(StorageService);

  /**
   * echo instance
   * @type {Echo}
   */
  private echo: Echo<any> = null;
  /**
   * company id
   * @type {number}
   */
  public companyId = null;
  /**
   * user id
   * @type {number}
   */
  public userId = null;


  /**
   * Gets the Echo instance for the current company and user.
   * If the instance is null, it will call the refreshSocket method to create a new instance.
   * @returns {Echo} The Echo instance.
   */
  getEchoInstance(): Echo<any> {
    if (!this.echo) {
      this.refreshSocket();
    }
    return this.echo;
  }
  /**
   * Refreshes the Echo socket connection for the specified company and user.
   * Updates the companyId and userId with the provided values.
   * The Echo instance uses socket.io as the broadcaster and sets up authentication headers.
   *
   * @param {number} [companyId=this.companyId] - The ID of the company.
   * @param {number} [userId=this.userId] - The ID of the user.
   * @returns {void}
   */
  refreshSocket(companyId = this.companyId, userId = this.userId): void {
    window.Pusher = Pusher;
    this.companyId = companyId;
    this.userId = userId;
    const region = this.storageService.getUserRegion();

    this.echo = new Echo({
      broadcaster: 'reverb',
      key: environment.reverbAppKey,
      wsHost: environment.socketUrl.replace('api', `${region}.api`),
      wsPort: 443,
      wssPort: 443,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
      authEndpoint: `${environment.apiUrl.replace('api', `${region}.api`)}broadcasting/auth`,
      auth: {
        headers: {
          Authorization: 'Bearer ' + this.storageService.getToken(),
        },
      },
    });
  }
  /**
   * Disconnects the Echo socket connection if it exists.
   * Sets the Echo instance to null after disconnecting.
   *
   * @returns {void}  
   */
  disconnectSocket(): void {
    if (this.echo) {
      this.echo.disconnect();
      this.echo = null;
    }
  }
}
